import React from 'react';

const ShapeRectangle = () => (
    <svg width='182' height='54' viewBox='0 0 182 54' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <rect x='3.58765' y='1.07422' width='48' height='49' rx='4' fill='#CCF3FF' />
        <rect x='0.75' y='4.31934' width='47.8562' height='47.8562' rx='3.25' stroke='black' strokeWidth='1.5' />
        <rect x='74.24' width='33.5983' height='51.2817' rx='4' fill='#F4C1C4' />
        <rect x='72.3376' y='2.58398' width='32.9825' height='50.6658' rx='3.25' stroke='black' strokeWidth='1.5' />
        <rect x='181.838' y='8.84668' width='33.6189' height='50.4283' rx='4' transform='rotate(90 181.838 8.84668)' fill='#FEE1BF' />
        <rect x='179.286' y='11.3994' width='33.0036' height='50.6978' rx='3.25' transform='rotate(90 179.286 11.3994)' stroke='black' strokeWidth='1.5' />
    </svg>
);

export default ShapeRectangle;
